module.exports = __webpack_public_path__ + "static/media/MTL_SL_IRON1.ee941bbd.png";